// extracted by mini-css-extract-plugin
export default {"shortcut":"Shortcut-styles-module--shortcut--Pi_vn text-monospace"};